module.exports = __webpack_public_path__ + "img/EJ-WHEELS.8589ea31.png";